import Backbone from "../../libs/backbone/backbone";
import GenericModel from "./generic.model.ts";

export default GenericModel.extend(
{
    urlRoot : 'rest/api/counters',
    id : null,
    queueId : "",
    agentId : "",
    status : "",

});

